import { render, staticRenderFns } from "./LeaderboardGrid.vue?vue&type=template&id=07b36425&scoped=true&"
import script from "./LeaderboardGrid.vue?vue&type=script&lang=ts&"
export * from "./LeaderboardGrid.vue?vue&type=script&lang=ts&"
import style0 from "./LeaderboardGrid.vue?vue&type=style&index=0&id=07b36425&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b36425",
  null
  
)

export default component.exports